import AxiosClient from "@/utils/api/axiosClient";

const config = window.rs_wechat;

class RewardApi extends AxiosClient {
  public apiBaseUrl = `${config.base_url}/affiliate-rewards/rewardsStatus`;

  public getLocaleInfo = async () => {
    const queryParams = {
      action: "get_localeinfo_data"
    };
    const response = await this.axiosClient.get<LocaleInfo>(
      `${this.apiBaseUrl}`,
      {
        params: queryParams
      }
    );

    return response;
  };

  public getSummaryData = async () => {
    const queryParams = {
      action: "get_summary_data"
    };
    const response = await this.axiosClient.get<RewardSummaryData>(
      `${this.apiBaseUrl}`,
      {
        params: queryParams
      }
    );

    return response;
  };

  public getActivityData = async (
    startdate: string,
    enddate: string,
    currency: Currencies
  ) => {
    const queryParams = {
      startdate,
      enddate,
      action: "get_currentactivity_data",
      currency
    };

    const response = await this.axiosClient.get<string>(`${this.apiBaseUrl}`, {
      params: queryParams
    });

    return JSON.parse(response) as RewardActivityData[];
  };
}

export default new RewardApi();
